<div class="timeout-container">
  <img src="/assets/images/time-out.png" alt="timeout" />
  <div class="timeout-alert">Your session has timed out!</div>
  <div class="timeout-description">Please log in again to continue where you left off.</div>
  <sdc-design-button
  type="primary"
  title="Sign in"
  width="220px"
  height="40px"
  (click)="signIn()"
></sdc-design-button>
</div>
